var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dark-mode-switcher",attrs:{"href":"javascript:;","title":_vm.$t('changeContrast')}},[_c('IconContrastSvg',{on:{"click":function($event){$event.preventDefault();return _vm.darkModeToggle($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }